<template>
  <Layout2
    title="Verify your email"
    padTop="200px"
  >
    <template slot="form">
      <form @submit.prevent="">
        <div>
          <label class="col_secondary fn14">Enter the verification code received on <strong style="font-weight: bold">{{user_email}}</strong></label>
          <div class="form-floating mt10">
            <input
              type="text"
              id="verificationCode"
              placeholder="Email Verification Code"
              class="form-control fn14"
              name="verificationCode"
              v-model="emailVerifyCode"
              v-validate="'required'"
            />
            <label for="verificationCode fn14">Email Verification Code</label>
            <small class="col_error" v-show="errors.has('verificationCode')">{{ errors.first('verificationCode') }}</small>
          </div>
        </div>
        <div class="mb20 mt20">
          <vue-recaptcha v-if="!(isMobileRequired && emailVerified)" id="recaptcha" ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired" :sitekey="recaptchaSiteKey" size="invisible"></vue-recaptcha>
          <input v-if=!submitted type="submit" class="btn btn-apiculus-primary" value="CONTINUE" :disabled="!verificationCodeValid"  @click="submitted=true;initiateEmailVerification()" />
          <button v-if=submitted class="btn btn-apiculus-primary" type="button">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading...
          </button>
        </div>
      </form>
    </template>
  </Layout2>
</template>

<script>
import Layout2 from './Layout2.vue'
import VueRecaptcha from 'vue-recaptcha'
import { mapGetters } from 'vuex'
import helpers from '../../services/toast-service'

export default {
  name: 'VerifyEmailOTP',
  mixins: [helpers],
  data () {
    return {
      email: '',
      emailVerifyCode: '',
      color: '',
      message: '',
      resendLink: false,
      errorMeta: {},
      remaining: false,
      remainingAttempts: '',
      user_email: '',
      emailVerifyCode: '',
      emailVerified: false,
      emailVerificationRes: {},
      OTP: '',
      showResendBtn: true,
      counterMessage: false,
      countDown: '',
      recaptcha_response: '',
      form: {},
      submitted: false
    }
  },
  components: {
    Layout2,
    VueRecaptcha   
  },
  computed: {
     ...mapGetters({
      getCountryName: 'getCountryName',
      getCountryState: 'getCountryState',
      profileDetails: 'getprofileDetails'
    }),
    getUserEmail () {
      // console.log(this.$route, this.$route.query.email)
      return this.$route.query.email || ''
    },
    isMobileRequired () {
      return (this.$store.state.ApiculusEnv && this.$store.state.ApiculusEnv.mobileRequired) || Boolean(false)
    },
    verificationCodeValid () {
      // console.log(this.emailVerifyCode && this.fields.code && this.fields.code.valid)
      return this.emailVerifyCode && this.fields && this.fields.verificationCode && this.fields.verificationCode.valid
    },
    otpValid () {
      // console.log(this.OTP , ' -- ', this.fields.otp)
      return this.OTP && this.fields && this.fields.otp && this.fields.otp.valid
    },
    counterTime () {
      return this.$store.state.ApiculusEnv.OTPTimer || 20
    },
    recaptchaSiteKey () {
      return JSON.parse(localStorage.getItem('ApiculusEnv')).siteKey
    }
  },
  mounted () {
    this.user_email = this.getUserEmail
    this.countDown = this.counterTime
  },
  methods: {
        otpTimer () {
      let interval = setInterval(() => {
        this.countDown--
        if (this.countDown <= 0) {
          this.counterMessage = false
          this.showResendBtn = true
          clearInterval(interval)
        }
      }, 1000)
    },
    onCaptchaVerified (res) {
      // console.log('onCaptchaVerified >> ', res)
      if (res && res.length) {
        this.recaptcha_response = res
        this.verifyEmail()
      } else {
        this.toastAlert('Error in verifying the reCAPTCHA', 'error')
      }
    },
    onCaptchaExpired (res) {
      this.recaptcha_response = ''
      this.$refs.recaptcha.reset()
    },
    initiateEmailVerification () {
      this.$refs.recaptcha.execute()
    },
    verifyEmail () {
      // console.log('token :: ', this.recaptcha_response)
      if (this.recaptcha_response && this.verificationCodeValid) {
        let reqBody = {
          'email': this.user_email,
          'tempPassword': this.emailVerifyCode,
          'g-recaptcha-response': this.recaptcha_response
        }
        this.$store.dispatch('ACTION_VERIFY_EMAIL', reqBody).then((res) => {
          this.submitted = false
          // debugger
          if (!res.success) {
            this.toastAlert(res.error.internalMessage || res.error.message || 'Verification link invalid/expired. Please try to resend the verification link.', 'error')
            setTimeout(() => {
              this.$router.push('/signup')
            }, 3000)
          } else if (res.success && res.result && res.result.verified) {
            this.emailVerified = true
            this.emailVerificationRes = res.result
            if (!this.isMobileRequired && this.emailVerified) {
              let obj = { ...res.result, emailVerified: this.emailVerified }
              this.$router.push({ name: 'SetNewPassword', params: obj })
            }
            else {
              let obj = { ...res.result, emailVerified: this.emailVerified }
              this.$router.push({ name: 'mobileVerification', params: obj })
              
            }
          }
        })
      }
    },
    verifyOTP () {
      this.$set(this.emailVerificationRes, 'otp', this.OTP)
      this.$store.dispatch('ACTION_VERIFY_OTP', this.emailVerificationRes).then(res => {
        if (!res.success) {
          this.toastAlert(res.error.message || 'OTP expired.', 'error')
        } else if (res.success && res.result.verified) {
          this.toastAlert('OTP verified successfully', 'success')
          let obj = { ...res.result, mobileVerified: true, emailVerified: this.emailVerified }
          this.$router.push({ name: 'SetNewPassword', params: obj })
        }
      })
    },
    resendOTP () {
      this.$store.dispatch('ACTION_RESEND_SIGNUP_OTP', { ...this.emailVerificationRes }).then(res => {
        if (!res.success) {
          this.toastAlert(res.error.message || 'Something went wrong.', 'error')
        } else {
          this.toastAlert('OTP sent successfully.', 'success')
        }
      })
      this.counterMessage = true
      this.countDown = this.counterTime
      this.showResendBtn = false
      this.otpTimer()
    }
}
}
</script>

<style scoped>
.c_select>.v-input__control>.v-input__slot:before { 
  border-style: none; 
} 
.c_select>.v-input__control>.v-input__slot:after { 
  border-style: none; 
}

</style>
